import { Directive, Input } from "@angular/core";

export interface FormAction {
    text?: string;
    icon?: string;
    iconResolver?: (any) => string;
    class?: string;
    actionHandler?: (arg0: any, e?: any) => void;
    disabled?: (arg0: any) => boolean;
    hidden?: (arg0: any) => boolean;
}

@Directive()
export abstract class ActionFormBase<T> {
    @Input() actionItem: T;
    @Input() actions: FormAction[]  = [];

    public clickHandler(e, action: FormAction) {
        e.preventDefault();      
        if(!!action.actionHandler && !this.isDisabled(action)) action.actionHandler(this.actionItem, e);
    }

    public classResolver(action: FormAction): string {
        return !!action.class ? ` ${action.class}` : '';
    }

    public iconResolver(action: FormAction): string {
        return !!action.icon ? action.icon : !!action.iconResolver ? action.iconResolver(action) : '';
    }

    public isDisabled(action: FormAction): boolean {
        return !!action.disabled && action.disabled(this.actionItem);
    }

    public isHidden(action: FormAction): boolean {
        return !!action.hidden && action.hidden(this.actionItem);
    }
    
    public hasIcon(action: FormAction): boolean {
        return !!action.icon || !!action.iconResolver;
    }
}